import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { LoadTask } from 'src/app/model/task-list/load-task';
import PlacerPlanningViewGeneralTaskHelper, {
  PlacerPlanningViewContext,
} from './placer-planning-view-general-task-helper';
import * as moment from 'moment-timezone';
import DateHelper from 'src/app/helpers/date-helper';
import { OfflineTaskChangesObject } from 'src/app/services/placer-offline-changes/task/offline-storage/offline-task-changes-object';

export default class PlacerPlanningViewLoadTaskHelper {
  private constructor() {}

  public static preprocessLoadTask(
    task: LoadTask,
    context: PlacerPlanningViewContext,
    taskIdToChanges: Map<number, OfflineTaskChangesObject>
  ): void {
    PlacerPlanningViewGeneralTaskHelper.fillOfflineTaskInfo(
      task,
      taskIdToChanges
    );
    PlacerPlanningViewGeneralTaskHelper.calculateCompaniesDisplay(task);
    PlacerPlanningViewGeneralTaskHelper.preprocessTimeBudgettedTask(task);
    this.calculatePlacementDateDisplay(task, context);
    this.calculateDisplayProduct(task);
  }

  private static calculatePlacementDateDisplay(
    task: LoadTask,
    context: PlacerPlanningViewContext
  ): void {
    if (
      task.subProject != null &&
      task.subProject.currentConfirmedPlacementDate != null
    ) {
      const placementMoment = moment(
        task.subProject.currentConfirmedPlacementDate
      ).tz(DateHelper.DEFAULT_TIME_ZONE);
      task.placementDateDisplay = context.formatMoment.transform(
        placementMoment,
        '-',
        'ddd DD/MM'
      );
    } else {
      task.placementDateDisplay = '-';
    }
  }

  private static calculateDisplayProduct(task: LoadTask): void {
    if (task.product != null) {
      task.displayProduct = task.product;
    } else if (
      task.subProject != null &&
      task.subProject.project != null &&
      CollectionHelper.isPopulated(task.subProject.project.products)
    ) {
      task.displayProduct = task.subProject.project.products[0];
    }
  }
}
